<template>
  <div class="card">
    <slot name="header" />
    <div class="card-container">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  mixins: [],
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.card {
  border-radius: 10px;
  padding: 16px;
  background-color: white;
  // height: 200px;
  // display: flex;
  // flex-direction: column;

  .card-container {
    // display: flex;
    // align-items: stretch;
    flex: 1;

    overflow: hidden;
  }
}
</style>
